/* eslint-disable */

/** select columns of table "argo.vw_user_context_acl" */
export enum ArgoVwUserContextAclSelectColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  UserId = 'user_id'
}

